export default __webpack_public_path__ + "static/media/meals.10128b90.jpg";